
<template>
    <div class="daily-comparison">
        <div class="container daily-comparison__container">
            <div class="row">

                <!-- Dev Note: 
                    Each "day" is one table inside here.
                -->
                <div v-for="(table, index) in theData" 
                    :key="index" 
                    class="col-12 col-md-6 daily-comparison__grid" 
                    :class="{'is-active': table.active != false}" 
                    v-on:click="table.active = !table.active">
                    <div class="daily-comparison__grid-titles">
                        <span class="daily-comparison__grid-category" v-html="table.tableName.preTitle"></span>

                        <h2 class="daily-comparison__grid-title" v-html="table.tableName.title"></h2>

                        <h6 class="daily-comparison__grid-day" v-html="table.tableName.day"></h6>
                    </div>

                    <div class="row daily-comparison__grid-data">
                        <div v-for="(item, rateIndex) in table.rates" 
                            :key="rateIndex" 
                            class="col-12 col-lg-4 daily-comparison__grid-data-item">
                            <span class="daily-comparison__grid-rate-label" v-html="item.title"></span>

                            <span class="daily-comparison__grid-rate-date" v-html="item.date"></span>

                            <span class="daily-comparison__grid-rate" v-html="item.rate"></span>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            tables: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                theData: []
            }
        },
        beforeMount() {
            this.theData = this.tables;
        }
    }
</script>



// WEBPACK FOOTER //
// src/app/components/phd/daily-rate-comparison.vue